import { render } from "./overviewPermissionGroup.vue?vue&type=template&id=697f6c72"
import script from "./overviewPermissionGroup.vue?vue&type=script&lang=js"
export * from "./overviewPermissionGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__